export default "__VITE_ASSET__CtJda3AR__"